import {
  Heading,
  Box,
  Stack,
  Badge,
  Center,
  Text,
  useColorModeValue,
  Image,
  Link,
} from "@chakra-ui/react";

import { Link as ReactRouterLink } from "react-router-dom";

export default function Preview(props) {
  const { image, title, content, tags, path } = props;

  return (
    <Link as={ReactRouterLink} to={path} style={{ textDecoration: "none" }}>
      <Center height="100%" m={10}>
        <Box
          maxW={"320px"}
          w={"full"}
          height={"100%"}
          bg={useColorModeValue("white", "gray.900")}
          boxShadow={"xl"}
          rounded={"lg"}
          p={6}
          textAlign={"center"}
        >
          <Center>
            <Image
              src={image}
              rounded={"lg"}
              height={100}
              width={100}
              objectFit={"cover"}
              m="5"
            />
          </Center>
          <Heading mb="2" fontSize={"2xl"} fontFamily={"body"}>
            {title}
          </Heading>
          <Text
            textAlign={"center"}
            color={useColorModeValue("gray.700", "gray.400")}
            px={3}
          >
            {content}
          </Text>
          {tags && (
            <Stack align={"center"} justify={"center"} direction={"row"} mt={6}>
              {tags.map((tag, index) => (
                <Badge key={index} px={2} py={1} fontWeight={"400"}>
                  {tag}
                </Badge>
              ))}
            </Stack>
          )}
        </Box>
      </Center>
    </Link>
  );
}
